import Swiper, { Pagination, Navigation } from 'swiper';
Swiper.use([Pagination, Navigation]);
import gsap from "gsap";

/**
 * BACKGROUND ROTATOR STANDALONE MODULE
 */

export namespace BackgroundRotator {
	/**
	 * Function for setting up slide functions - Dave created a method for adding removing classes based on being in viewport
	 * @param element
	 */
	let SlideChangeFunctions = (element) => {
		let actions = element.getAttribute('data-slide-change');

		if (!actions) {
			return;
		}

		if (typeof(actions) === 'string') {
			actions = [{
				action: actions,
				target: element.data('target'),
				delay: element.data('delay') || 0
			}];
		}

		for (let i = 0; i < actions.length; i++) {
			let nextSequence = actions[i];
			let nextAction = nextSequence.action;
			let $nextTarget = element.find(nextSequence.target) || element;
			let delay = nextSequence.delay || 0;

			switch (nextAction) {
				case 'applyClass':
				case 'apply-class':
					gsap.delayedCall(delay, function () {
						let scrollClass = nextSequence.class;
						$nextTarget.addClass(scrollClass);
					});
					break;
				case 'removeClass':
				case 'remove-class':
					gsap.delayedCall(delay, function () {
						let scrollClass = nextSequence.class;
						$nextTarget.removeClass(scrollClass);
					});
					break;
			}
		}
	};

	/**
	 * This function sets up our background rotator code
	 * @constructor
	 */
	let SetupBackgroundRotators = () => {
		//Preload our faucet images so they pop in nice and fast when we transition
		let preloadImgs = [];
		let bgRotatorListItems = document.querySelectorAll<HTMLElement>('.background-rotator__list-item');
		let bgRotators = document.querySelectorAll<HTMLElement>('.js-background-rotator');

		/**
		 * Preloads Images
		 */
		bgRotatorListItems.forEach((item) => {
			let img = new Image();
			img.src = item.getAttribute('data-img');
			if(img.src) {
				preloadImgs.push(img);
			}
		});

		/**
		 * Setup Rotator for each background rotator on the page
		 */
		bgRotators.forEach((rotator, index) => {
			let sliderList = [];
			rotator.classList.add(`background-rotator-${index}`);
			let rotatorParent = rotator.closest('.background-rotator');
			let leftArrow = rotatorParent.querySelector('.swiper-button-prev');
			let rightArrow = rotatorParent.querySelector('.swiper-button-next');
			leftArrow.classList.add(`background-rotator__prev--${index}`);
			rightArrow.classList.add(`background-rotator__next--${index}`);

			let swiper = new Swiper(`.background-rotator-${index}`,{
				slidesPerView: 1,
				init: false,
				loop: false,
				speed: 600,
				preventInteractionOnTransition: true,
				navigation: {
					nextEl: `.background-rotator__next--${index}`,
					prevEl: `.background-rotator__prev--${index}`,
				}
			});

			sliderList.push(swiper);

			swiper.on('init', () => {
				SlideChangeFunctions(swiper.$el[0]);
				let swiperParent = swiper.el.closest('.background-rotator');
				let activeImageSrc = swiper.slides[swiper.activeIndex].getAttribute('data-img');
				let activeImageAlt = swiper.slides[swiper.activeIndex].getAttribute('data-alt');
				let bgImage = swiperParent.querySelector('.js-bg-img');
				bgImage.setAttribute('src', activeImageSrc);
				bgImage.setAttribute('alt', activeImageAlt);
			});

			//transition start functions
			swiper.on('transitionStart', () => {
				let swiperParent = swiper.el.closest('.background-rotator');
				let activeImageSrc = swiper.slides[swiper.activeIndex].getAttribute('data-img');
				let activeImageAlt = swiper.slides[swiper.activeIndex].getAttribute('data-alt');
				let bgImg = swiperParent.querySelector('.js-bg-img');
				let bgClone = document.createElement('img');
				let pNode = bgImg.parentNode;
				bgClone.classList.add('background-rotator__bg');
				bgClone.classList.add('background-rotator__bg-cloned');
				bgClone.classList.add('js-cloned-img');
				bgClone.setAttribute('alt', bgImg.getAttribute('alt'));
				pNode.insertBefore(bgClone, bgImg);
				let clonedImage = swiperParent.querySelector('.js-cloned-img');
				clonedImage.setAttribute('src', activeImageSrc);
				clonedImage.setAttribute('alt', activeImageAlt);
				bgImg.classList.add('state-fading');
			});

			swiper.on('transitionEnd', () => {
				let swiperParent = swiper.el.closest('.background-rotator');
				let fadingDiv:HTMLElement = swiperParent.querySelector('.state-fading');
				fadingDiv.remove();
				let clonedImage = swiperParent.querySelector('.js-cloned-img');
				clonedImage.classList.remove('background-rotator__bg-cloned');
				clonedImage.classList.remove('js-cloned-img');
				clonedImage.classList.add('js-bg-img');

				setTimeout(() => {
					SlideChangeFunctions(swiperParent);
				}, 250);
			});

			swiper.init();

		});
	}


	/**
	 * Initialize our Background Rotator Module
	 */
	export const init = () => {
		SetupBackgroundRotators();
	}
}

/**
 * DOMContentLoaded may fire before script has a chance to run, so it is wise to check before adding
 */
if (document.readyState === 'loading') {  // Loading hasn't finished yet
	document.addEventListener('DOMContentLoaded', BackgroundRotator.init);
} else {  // `DOMContentLoaded` has already fired
	BackgroundRotator.init();
}
